import { useState } from 'react';

export default function App() {
	const [bill, setBill] = useState('');
	const [people, setPeople] = useState('');
	const [tip, setTip] = useState('');
	let tipAmount = bill * (tip / 100);
	let totalAmount = people && (bill + tip) / people;
	function handleClick(e) {
		setTip(+e.target.textContent.slice(0, -1));
	}
	function handleReset() {
		setBill(b => (b = ''));
		setPeople(p => (p = ''));
		setTip(t => (t = ''));
		tipAmount = '';
		totalAmount = 0;
	}
	return (
		<main>
			<div className="calculator">
				<div className="calculator__left">
					<Input value={bill} onChange={setBill}>
						Bill
					</Input>
					<Tip tip={tip} setTip={setTip} onClick={handleClick} />
					<Input value={people} onChange={setPeople}>
						Number of People
					</Input>
				</div>
				<div className="calculator__right">
					<Amount value={tipAmount}>Tip Amount</Amount>
					<Amount value={totalAmount}>Total</Amount>
					<Button onClick={handleReset}>RESET</Button>
				</div>
			</div>
		</main>
	);
}
function Tip({ tip, setTip, onClick }) {
	const tipPercent = [5, 10, 15, 25, 50];
	return (
		<form className="form">
			<label for="tip">Select Tip %</label>
			<div className="calculator--tipPercent">
				{tipPercent.map((tips, i) => (
					<Button onClick={onClick} tip={tip} key={i}>
						{tips}%
					</Button>
				))}
				<input
					value={tip}
					type="text"
					placeholder="Custom"
					name="tip"
					id="tip"
					onChange={e => setTip(+e.target.value)}
				></input>
			</div>
		</form>
	);
}

function Input({ value, onChange, onTipChange, children }) {
	return (
		<form className="form">
			<label for="bill">{children}</label>
			<input
				type="text"
				placeholder="$"
				name="bill"
				id="bill"
				value={value}
				onChange={e => onChange(+e.target.value)}
			/>
		</form>
	);
}
function Amount({ value, children }) {
	return (
		<div className="calculator__person">
			<div className="calculator__personContent">
				<p>{children}</p>
				<span>/ person</span>
			</div>
			<p className="calculator__personAmount">${value}</p>
		</div>
	);
}
function Button({ tip, onClick, children }) {
	return (
		<button type="button" onClick={onClick}>
			{children}
		</button>
	);
}
